<template>
  <a-drawer
    v-if="visible"
    class="custom-class"
    style="color: red"
    :title="title"
    placement="right"
    width="400"
    @close="onClose"
  >
    <template v-for="(item, index) in list" key="item.id">
      <p @click="confirm(item)">
        <a-badge :color="item.is_confirmed ? '#000' : '#f50'" />
        <span style="color: #0a001f">
          近三天时间卡到期数：{{ item.count }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 时间：{{
            item.query_date
          }}
        </span>
      </p>
      <a-divider style="margin-bottom: 10px; margin-top: 5px" v-if="index < list.length - 1" />
    </template>
  </a-drawer>
</template>

<script lang="ts">
import { confirm_card_record_time_alert } from '@/api/mjstore-model';
import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import modalBox from '@/components/form-modal/modal-tools';
export default defineComponent({
  name: 'TipsModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any) {
    const store = useStore();
    const current_org = computed(() => store.getters['user/current_org']);
    const current_shop = computed(() => store.getters['user/current_shop']);
    const visible = ref<boolean>(true);
    const search = reactive({
      current: 1,
      pageSize: 1000,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.value.id,
        is_active: true,
      },
    });
    const confirm = (data: any) => {
      confirm_card_record_time_alert({
        org_id: current_org.value?.id,
        card_record_time_alert_id: data.id,
        shop_id: current_shop.value?.id,
      });
      const editModal = reactive({
        visible: true,
        component: 'TablePageModal2',
        obj: {
          title: '近三天到期时间卡',
          search: {
            ...search,
            requestParams: { ...search.requestParams, card_record_time_alert_id: data.id },
          },
          modalType: 'mjstore-tips',
        },
      });
      modalBox(editModal);
    };
    const onClose = () => {
      visible.value = false;
    };
    return {
      visible,
      confirm,
      onClose,
    };
  },
});
</script>
<style>
.custom-form-modal .ant-modal-body {
  max-height: 600px;
  overflow: auto;
}
/*.ant-form-item {*/
/*  margin-bottom: 6px;*/
/*}*/
.custom-form-modal1 .ant-modal-body {
  max-height: 670px;
  overflow: auto;
}
</style>
